export function setAllConversations(consumerId, data) {
  return {
    type: 'SET_ALL_CONVERSATION_HISTORY',
    payload: { consumerId, data },
  }
}

export function setConversations(data) {
  return {
    type: 'SET_CONVERSATION_HISTORY',
    payload: data,
  }
}

export function deleteConversation(data) {
  return {
    type: 'DELETE_CONVERSATION_HISTORY',
    payload: data,
  }
}

export function deleteConversations(data) {
  return {
    type: 'DELETE_ALL_CONVERSATION_HISTORY',
    payload: {},
  }
}

export function setMessages(data) {
  return {
    type: 'SET_MESSAGES_HISTORY',
    payload: data,
  }
}

export function deleteMessages(data) {
  return {
    type: 'DELETE_MESSAGES_HISTORY',
    payload: data,
  }
}

export function setConversationProtocol(consumerId, data) {
  return {
    type: 'SET_CONVERSATION_HISTORY_PROTOCOL',
    payload: { consumerId, data },
  }
}
